window.VegasCatalog.Order = {
	make: function ($form, callback) {
		let route = $form.attr('action');
		let params = $form.serializeArray();

		$.post(route, params, function (data) {
			if (callback) {
				callback(data);
			}
		})
	},

	CDEK: {
		cdekWidget: null,
		init: function () {
			if (VegasCatalog.Order.CDEK.cdekWidget) return;
			VegasCatalog.Order.CDEK.cdekWidget = new window.CDEKWidget({
				apiKey: App.mapKey,
				defaultLocation: 'Калуга',
				from: 'Калуга',
				popup: true,
				servicePath: location.protocol + '//' + location.host + '/cdek/service.php',
				canChoose: true,
				hideFilters: {
					have_cashless: false,
					have_cash: false,
					is_dressing_room: false,
					type: false,
				},
				lang: 'rus',
				currency: 'RUB',
				onChoose(type, tariff, address) {
					VegasCatalog.Order.CDEK.selectAddr(type, tariff, address);
					VegasCatalog.Cart.updateTotalAll();
					VegasCatalog.Order.CDEK.close();
				},
				tariffs: {
					office: [234, 136, 185, 62, 483],
					door: [137, 233, 186, 122, 482],
				},
			});
		},
		selectAddr: function (type, tariff, wat) {
			console.log(type, tariff, wat)
			let $formOrder = $("#form-cart");

			$formOrder.find('[name=cdek_office_code]').val('');
			$formOrder.find('[name=cdek_city_code]').val('');
			$formOrder.find('[name=cdek_tariff_code]').val(tariff.tariff_code);

			let addr = '';
			if (type === 'door') {
				addr = [
					wat.city,
					wat.formatted
				].join(', ');
			} else if (type === 'office') {
				addr = [
					wat.city,
					`${wat.address}, ПВЗ #${wat.code}`,
				].join(', ');

				$formOrder.find('[name=cdek_office_code]').val(wat.code);
				$formOrder.find('[name=cdek_city_code]').val(wat.city_code);
			}

			$formOrder.find("#user_address-cdek").val(addr);
			$formOrder.find('.user_address_cdek').html(addr);

			$formOrder.find('[name=cdek_type]').val(type);
			//$formOrder.find('[name=cdek_to_city]').val(wat.city);
		},
		open: function () {
			VegasCatalog.Order.CDEK.cdekWidget.resetParcels();
			$('.catalog-cart--products [data-product-cart-item][data-cdek-config]').each(function () {
				let config = $(this).data('cdek-config');
				let cnt = parseInt($(this).find('input[name=total]').val());
				for(let i = 1; i <= cnt; i++) {
					console.log(config)
					VegasCatalog.Order.CDEK.cdekWidget.addParcel(config);
				}
			});
			VegasCatalog.Order.CDEK.cdekWidget.open();
		},
		close: function () {
			VegasCatalog.Order.CDEK.cdekWidget.close();
		}
	},

	Courier: {
		init: function () {
			let $userAddressCourier = $("#user_address_courier");
			let validCourierAddresses = [$userAddressCourier.data('validaddress')];
			let $mapAddress = $("#map-courier-address");

			setTimeout(function () {
				if (typeof ymaps !== 'undefined' && $mapAddress.length) {
					let $userAddressCourier = $("#user_address_courier");

					ymaps.ready(function () {
						let suggestView = new ymaps.SuggestView("user_address_courier");

						suggestView.events.add('select', function (e) {
							let addr = $.trim(e.get('item').value);
							validCourierAddresses.push(addr);
							$userAddressCourier.attr('data-old-addr', '');

							ymaps.geocode(e.get('item').value, {results: 1}).then(function (res) {
								var firstGeoObject = res.geoObjects.get(0),
									coordinates = firstGeoObject.geometry.getCoordinates();

								$("#form-cart").find('[name=user_address_courier_coordinates]').val(coordinates);

								VegasCatalog.Order.Courier.updatePrice();
							});
						});

						if ($userAddressCourier.length && $userAddressCourier.val()) {
							ymaps.geocode($userAddressCourier.val(), {results: 1}).then(function (res) {
								var firstGeoObject = res.geoObjects.get(0),
									coordinates = firstGeoObject.geometry.getCoordinates();

								$("#form-cart").find('[name=user_address_courier_coordinates]').val(coordinates);

								VegasCatalog.Order.Courier.updatePrice();
							});
						}
					});

					$userAddressCourier.on('blur', function () {
						let self = this;

						setTimeout(function () {
							let currentAddress = $(self).val();
							if (currentAddress) {
								let valid = false;
								for (let i in validCourierAddresses) {
									let validAddr = validCourierAddresses[i];
									if (!validAddr) continue;
									if (currentAddress.indexOf(validAddr) !== -1) {
										valid = true;
										break;
									}
								}

								if (!valid) {
									$(self).attr('data-old-addr', $(self).val());
									$(self).val('');
									alert('Выберите адрес из выпадающего списка!');
								}
							}
						}, 150);
					}).on('focus', function () {
						let addr = $(this).attr('data-old-addr');
						if (addr) {
							$(this).val(addr);
						}
					});

					$userAddressCourier.on('update-price', VegasCatalog.Order.Courier.updatePrice);
				}
			}, 1000);
		},

		updatePrice: function () {
			VegasCatalog.Cart.updateTotalAll();
		}
	}
};

$(document).ready(function () {
	let $formOrder = $("#form-cart");

	if ($formOrder.length) {
		VegasCatalog.Order.CDEK.init();
		VegasCatalog.Order.Courier.init();
	}

	$formOrder.find('[name=delivery_id]').on('change', function () {
		let id = $(this).attr('id'),
			val = parseInt($(this).val()),
			$containerOrder = $(this).closest('.catalog-cart--totals'),
			$containerDelivery = $containerOrder.find('.delivery-area--placement');

		// set show & active
		$containerDelivery.find('.active').removeClass('show active');
		let $currentDelivery = $containerDelivery.find('[data-id=' + id + ']');
		$currentDelivery.addClass('show active');

		// use required
		$('.delivery-area--placement .toggle-required').removeAttr('required');
		$currentDelivery.find('.toggle-required').attr('required', 'required');

		if (val === 3) {
			VegasCatalog.Order.CDEK.open();
		} else {
			VegasCatalog.Cart.updateTotalAll();
		}
	});

	$formOrder.find('.select-cdek-address').click(function () {
		VegasCatalog.Order.CDEK.open();
		return false;
	});

	$formOrder.submit(function () {
		$('.catalog-cart--preload').addClass('show');

		VegasCatalog.Order.make($formOrder, function (data) {
			if (data.error) {
				$('.catalog-cart--preload').removeClass('show')
				alert(data.msg);
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	$formOrder.on("keydown", function (event) {
		return event.key != "Enter";
	});
});
